import { Iconify } from "@repo/design-system/components/ui";
import PropTypes from "prop-types";
import React from "react";

const IconAddonCellComponent = ({ tooltipId = "", config, columnEvents = {},
    children, rowData, field }) => {

    const handler = columnEvents?.CELLICONCLICK;
    const { icon, width, className, ttLabel } = config;

    return (
        <>
            <div id={tooltipId} className="icon-cell">
                {children}
            </div>
            <Iconify icon={icon} width={width}
                className={`cursor-pointer ${className}`} ttLabel={ttLabel}
                targetId={tooltipId} onClick={() => handler?.(field, "", rowData)} />
        </>
    );
};

IconAddonCellComponent.propTypes = {
    field: PropTypes.string,
    width: PropTypes.number,
    icon: PropTypes.string,
    className: PropTypes.string,
    tooltip: PropTypes.string,
};

export const IconAddonCell = React.memo(IconAddonCellComponent);